<template>
  <v-main>
    <iframe v-if="url" id="iframe" :src="url" width="100%" height="100%" frameborder="0" marginWidth="0px" marginHeight="0px" scrolling="yes" seamless></iframe>
  </v-main>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import CONFIG from '@/constants/config.js'
export default {
  mixins: [layoutMixin],
  components:{
  },
  data(){
    return {
      url:CONFIG.FEATURE_IFRAME.url
    }
  },
  computed: {

  },
  methods: {
  }
}
</script>
